// extracted by mini-css-extract-plugin
module.exports = {"summary":"MealsSummary_summary__22zUX","display":"MealsSummary_display__3tg1Q"};